import cx from 'clsx';
import React, { useState } from 'react';

import { ReactComponent as SendIcon } from '@assets/svg/ic-send.svg';

import style from './style.module.scss';

interface IProps {
  isActive: boolean;
  isLoading: boolean;
  isDisabled: boolean;
  handleSend: () => void;
}

const SendBtnWithLoader: React.FC<IProps> = ({ isActive, isLoading, isDisabled, handleSend }) => {
  return (
    <div className={cx(style.chatLoader, { [style.isLoading]: isLoading })} onClick={handleSend}>
      <SendIcon
        className={cx(style.sendBtn, {
          [style.active]: isActive,
          [style.loadingSendBtn]: isLoading,
          [style.disabled]: isDisabled,
        })}
      />
    </div>
  );
};

export default SendBtnWithLoader;
